<template>
  <div class="card-button-box-main">
    <button type="button" @click="$router.push({name:'saveBox'})">
      <span class="icon-card"></span>
      <em>카드 보관함</em>
    </button>
    <button type="button" @click="$router.push({name:'mydetail'})">
      <span class="icon-board"></span>
      <em>주문 내역</em>
    </button>
  </div>
</template>

<script>
export default {
    name: 'ButtonBoxMain',
};
</script>

<style lang="scss">
    @import '@/assets/styles/common/buttonBox.scss';
</style>
